<div class="error-container">
    <h2>Oops! Something went wrong</h2>
    <p>{{ errorMessage }}</p>
    <p *ngIf="errorCode">Error Code: {{ errorCode }}</p>
    <app-buttons [props]="{
      icon: '',
      content: 'Retry',
      href: '#',
      classType: 'tertiary',
      type:'button'
    }" (click)="retry()"></app-buttons>
</div>